export enum CloudType {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
  REDHAT = 'REDHAT',
}

export type CloudProvidersType = 'AWS' | 'GCP' | 'AZURE'

export enum MappingManagerTemplateStatusType {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
}

export enum PartnerType {
  User = 'user',
  Admin = 'admin',
}

export type ProductType = 'oppsync' | 'cloudfaas' | 'flyout'

export interface AccountData {
  partnerId?: string
  partnershipType?: string[]
  [key: string]: unknown
}

export interface UserState {
  id: string
  name: string
  email: string
  roles: string[]
  firstName?: string
  lastName?: string
  [key: string]: unknown
}

export interface UserProfile {
  id?: string
  email?: string
  firstName?: string
  lastName?: string
  givenName?: string
  familyName?: string
  name?: string
  roles?: string[]
  timeZone?: string
  defaultTimeZone?: string
  [key: string]: unknown
}

export enum FlyOutListingUserType {
  NEW = 'NEW',
  MIGRATED = 'MIGRATED',
  MANAGED = 'MANAGED',
}

export enum CloudProvider {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
}
